import { render, staticRenderFns } from "./smartreply.vue?vue&type=template&id=00caabee&scoped=true"
import script from "./smartreply.vue?vue&type=script&lang=js"
export * from "./smartreply.vue?vue&type=script&lang=js"
import style0 from "./smartreply.vue?vue&type=style&index=0&id=00caabee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00caabee",
  null
  
)

export default component.exports